var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2554 3.22491C27.8021 2.67818 27.8021 1.79175 27.2554 1.24501C26.7086 0.698277 25.8222 0.698277 25.2755 1.24501L14 12.5205L2.72452 1.24501C2.17778 0.698277 1.29135 0.698277 0.744618 1.24501C0.197884 1.79175 0.197884 2.67818 0.744618 3.22491L12.0201 14.5004L0.744522 25.776C0.197789 26.3227 0.19779 27.2091 0.744524 27.7559C1.29126 28.3026 2.17769 28.3026 2.72442 27.7559L14 16.4803L25.2756 27.7559C25.8223 28.3026 26.7087 28.3026 27.2555 27.7559C27.8022 27.2091 27.8022 26.3227 27.2555 25.776L15.9799 14.5004L27.2554 3.22491Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossLarge);
export default __webpack_public_path__ + "static/media/cross_large.4c73f57789fe7dde9bb7a28ce71aec1d.svg";
export { ForwardRef as ReactComponent };